import {
  blobToObjectUrl,
  fetchAuthenticatedBlob,
  saveOrShareBlob,
} from "../utils/authenticatedBlob";
import apiClient, { extractData } from "./client";

export async function listSocialInsurance() {
  const response = await apiClient.get("/social-insurance");
  return extractData(response);
}

export async function saveSocialInsurance(employeeId, payload) {
  const response = await apiClient.put(
    `/social-insurance/${encodeURIComponent(employeeId)}`,
    payload,
  );
  return extractData(response);
}

export async function uploadSocialInsuranceAttachment(employeeId, { file, kind }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("kind", kind);
  const response = await apiClient.post(
    `/social-insurance/${encodeURIComponent(employeeId)}/attachments`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return extractData(response);
}

export async function deleteSocialInsuranceAttachment(id) {
  const response = await apiClient.delete(
    `/social-insurance/attachments/${encodeURIComponent(id)}`,
  );
  return extractData(response);
}

export async function downloadSocialInsuranceAttachment(id, originalName) {
  const blob = await fetchAuthenticatedBlob(
    `/social-insurance/attachments/${encodeURIComponent(id)}/download`,
    "تعذر تحميل المرفق",
  );
  await saveOrShareBlob(blob, originalName || "attachment");
}

export async function previewSocialInsuranceAttachment(id) {
  const blob = await fetchAuthenticatedBlob(
    `/social-insurance/attachments/${encodeURIComponent(id)}/download`,
    "تعذر عرض المرفق",
  );
  return blobToObjectUrl(blob);
}
